import { FC } from "react";
import LinkComponent from "@Components/Link";
import Image from "components/Image";
import { IRecipeCardProps } from "./RecipeSlider.types";
import classes from "./RecipeCard.module.scss";

const ProductTile: FC<IRecipeCardProps> = ({ className, item }) => {
  const {
    //slug,
    title = "",
    recipeCardDifficultyTitle,
    recipeCardDifficultyValue,
    recipeCardTimeTitle,
    recipeCardTimeValue,
    recipeCardServingTitle,
    recipeCardServingValue,
    imageList,
    linkToRecipe,
  } = item || {};
  const imageUrl = imageList?.items
    ? `${imageList?.items[0].url}?fm=webp&w=1024&h=768`
    : "";
  const imageTitle = imageList?.items ? imageList?.items[0].title : "";
  return (
    <div
      className={`
      ${className} 
      ${
        classes["recipe-card"] +
        " " +
        classes["recipe-card--featured"] +
        " " +
        classes["price--regular"] +
        " " +
        classes["price--same"] +
        " " +
        classes["recipe-card--gallery"] +
        " " +
        classes["tns-item"] +
        " " +
        classes["tns-slide-active"]
      }`}
    >
      <div className={classes["recipe-card__gallery"]}>
        <LinkComponent href={`/${linkToRecipe}/`}>
          <a aria-label={title} className={classes["recipe-card__link"]}>
            <div
              className={classes["responsive-image"]}
              data-availability="Back Soon"
              style={{
                aspectRatio: "100%",
                maxHeight: "500px",
                maxWidth: "500px",
                objectFit: "cover",
                objectPosition: "center",
              }}
            >
              <Image
                src={imageUrl}
                height={270}
                width={270}
                layout="responsive"
                alt={imageTitle}
              />
            </div>
          </a>
        </LinkComponent>
      </div>

      <h2 className={classes["recipe-card__title"]}>
        <LinkComponent href={`/${linkToRecipe}/`}>{title}</LinkComponent>
      </h2>

      <div className={classes["recipe-card__footer"]}>
        <div className={classes["recipe-card__packaging"]}>
          <span className={classes["recipe-details"]}>
            <span className={classes["recipe-details__label"]}>
              {`${recipeCardDifficultyTitle}: `}
              <b>{recipeCardDifficultyValue}</b>
            </span>
            <span className={classes["recipe-details__label"]}>
              {`${recipeCardTimeTitle}: `}
              <b>{recipeCardTimeValue}</b>
            </span>
            <span className={classes["recipe-details__label"]}>
              {`${recipeCardServingTitle}: `}
              <b>{recipeCardServingValue}</b>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProductTile;
